import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import useMobile from "../../hooks/useMobile";
import useTab from "../../hooks/useTab";
import { Element } from "react-scroll";
import Lightbox from "yet-another-react-lightbox";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Share from "yet-another-react-lightbox/plugins/share";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Video from "yet-another-react-lightbox/plugins/video";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { Fade } from "react-awesome-reveal";
import { useRoomContext } from "../../context/RoomContext";

interface IRoomSlider {
  id: number;
}

const RoomSlider = (props: IRoomSlider) => {
  const mobile = useMobile();
  const tab = useTab();
  const [open, setOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const { roomData } = useRoomContext();
  const filterRoomData = roomData.filter((room) => room?.id === props.id);
  const lightboxSlides = filterRoomData.flatMap((room) =>
    room.attributes.Images.data.map((image) => ({
      src: `${process.env.REACT_APP_strapiUrl}${image.attributes.url}`,
    })),
  );
  const handleSlideClick = (index: number) => {
    setLightboxIndex(index);
    setOpen(true);
  };
  return (
    <>
      <Element name="singleroom_gallery"></Element>
      <Fade direction="up" triggerOnce={true}>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-69e827d elementor-section-stretched elementor-section-full_width elementor-section-height-default elementor-section-height-default elementor-invisible"
          data-id="69e827d"
          data-element_type="section"
          data-settings='{"stretch_section":"section-stretched","animation":"fadeInUp","animation_delay":600,"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div className="elementor-row">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4008f9e"
                data-id="4008f9e"
                data-element_type="column"
                data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
              >
                <div className="elementor-column-wrap elementor-element-populated">
                  <div className="elementor-widget-wrap">
                    <div
                      className="elementor-element elementor-element-8d93419 elementor-widget elementor-widget-hoteller-gallery-horizontal"
                      data-id="8d93419"
                      data-element_type="widget"
                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="hoteller-gallery-horizontal.default"
                    >
                      <div className="elementor-widget-container">
                        <div
                          className="tg_horizontal_gallery_wrapper"
                          data-autoplay="0"
                          data-loop="0"
                          data-navigation="1"
                          data-pagination="0"
                          data-parallax="0"
                          data-fullscreen="0"
                        >
                          <div
                            className="tg_horizontal_gallery_cell custom-info-slideshow__slide-image"
                            style={{ height: "65dvh" }}
                          >
                            <Swiper
                              modules={[Navigation]}
                              slidesPerView={mobile || tab ? 2 : 3}
                              navigation
                              spaceBetween={10}
                              grabCursor={true}
                              style={{
                                height: "100%",
                              }}
                            >
                              {filterRoomData[0]?.attributes?.Images?.data.map(
                                (image, index) => {
                                  return (
                                    <SwiperSlide key={index}>
                                      <div
                                        className="slideshow__slide-image background-absolute custom-info-slideshow__slide-image"
                                        style={{
                                          height: "65dvh",
                                          backgroundImage: `url(${process.env.REACT_APP_strapiUrl}${image?.attributes?.url})`,
                                          backgroundRepeat: "no-repeat",
                                          backgroundSize: "cover",
                                          backgroundPosition: "center",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => handleSlideClick(index)}
                                      >
                                        <div className="custom-gradient"></div>
                                      </div>
                                    </SwiperSlide>
                                  );
                                },
                              )}
                            </Swiper>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Fade>
      <style>
        {`
                    .swiper-button-next,
                    .swiper-button-prev {
                        height: 26px;
                    }
                    .swiper-button-next::after,
                    .swiper-button-prev::after {
                        color: white;
                        font-size: 24px;
                    }
                    .swiper-pagination-bullet {
                        background-color: #ffffff;
                    }
                    .swiper-pagination {
                        bottom: 11px !important;
                    }
                    @media (max-width: 810px) {
                        .swiper-pagination {
                            bottom: 17px !important;
                        }
                    }
                `}
      </style>
      <Lightbox
        open={open}
        plugins={[
          Counter,
          Fullscreen,
          Share,
          Slideshow,
          Video,
          Zoom,
          Thumbnails,
        ]}
        close={() => setOpen(false)}
        slides={lightboxSlides}
        index={lightboxIndex}
      />
    </>
  );
};

export default RoomSlider;
